var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 36,
    viewBox: "0 0 39 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 36,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1990_2268",
    transform: "translate(-0.00167224) scale(0.0200669 0.0217391)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1990_2268",
    width: 50,
    height: 46,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAuCAYAAABqK0pRAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAxFJREFUeNrsWstx2zAQpTy+5cKccpU6oDqQKkhcgaUKpA5kVhCrAtEVyKmAdgViB+TVp/CSs7ObWWYQeBcAQfCjmewMhuMhCL63D/sBrSj6b8Pa2+zTHMYexgXGO42H5v5s6uDh8g3GPYyEm/Pl/dcfDrfXCJ6z24mAjwn8V7q62svoRDqAVy0dhUgg8H/VgPgYTpHA4Fk1es1aQEAFHzs+VtFc2/wK1Fj0FuwdwD/DeIKxg7Fpq0YQRTzB1wT+B3j2mdY5OZL4oIa3IqHAKzGUCzWjZtZPucVnLcAnVKQQ/LwLeEcSGYyV9q4a1vncuiD2AV5bOxcURRKvzFY7Old2T/BRAx6vQKB2cJBEYgvPZzCnZBz0aCVCi5/7Aq+8B7383UJiw+A4mt6hKpI7Bm5r8BqJk7Ad17BeQX/fC9vNqWmMLbk+9QGvkEAV9jYSMG9FQf4PCbhfmda/0Twt2bxtW62ROAkkEPxSUQLt4FIARSKw2B09IHkcvZQjKDozOPVZMM5CoStIiUqZ76WGrgiSwaPjwuIBBFXiMZPqgKlZzIVGMSMSutO42Di6OG1mOakdLG1DTdnkgXn2LBU6mL8V3lcyrfrahciNdAPlpBcu1ZOYZuj1A+Z8ykhNGr8IJFKORJfY8GlRVpQ6TfFR0H2xRhjU91bDqAij0At1nVtKx5wlDAncfncSCSXuvGKjUxtPgbyn80NsiaG1ll65tUptHbZVD6KIpk6tZLhHw1QjCbK9a6seXBFhj3NZamGqAaHU8FaEy3AUO7rtLI9yB7OjD4agHx/wu6ymingQovmlfnAiFetRFDF4M27qi9AJt2rVB1OEAP7UtksB4JZ9qtGHIty5IaFqr3+8mDOtS+370j6IHB2Cfte1APZOhDKY3pttmk65S6s+tCKSdzchmsPBgt0QzOjxNdMcZoaOeHRF0J6Y4/LZYd7kFOFa86hLqz6KIhS8mWVaGup9fW4t27Yp1P84TZoIAa1aZLbJKiIBriwnxkkSyaKP38rS6BoNO13lZxeX6JqNfkuS9LX+bwEGAEskdGZbvYN/AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.df9b3c4570b86b99d3c947cd6fa75a6b.svg";
export { ForwardRef as ReactComponent };